module.exports = __webpack_public_path__ + "static/media/Notes_Icon_White.4c24223b.svg";